import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import EventIcon from '@mui/icons-material/Event';
import Box from '@mui/material/Box';
import CalenderEvents from '../calendarEvents/CalenderEvents';
import RequestShifts from './RequestShifts';

const ShiftsCalendarView = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <CalenderEvents
        title="Shifts Calendar"
        secondary={
          <Button
            variant="contained"
            color="primary"
            onClick={handleModalOpen}
            startIcon={<EventIcon />}
          >
            View Requested Shifts
          </Button>
        }
      />

      {/* Modal for showing requested shifts */}
      <Dialog open={isModalOpen} onClose={handleModalClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleModalClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[500],
              backgroundColor: 'transparent',
              width: 40,
              height: 40,
              '&:hover': {
                backgroundColor: (theme) => theme.palette.grey[200]
              },
              borderRadius: '50%'
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Box>
            <RequestShifts />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ShiftsCalendarView;
